import { getApi } from "../client/apiClient";
import type { HttpClient } from "../client/types";
import type {
  LoginAdministratorRequest,
  LoginLifeguardRequest,
  LifeguardPreLoginRequest,
  LoginResponse,
  VerifyUserRequest,
} from "../client/types/auth.types";

const createAuthEndpoints = (client: HttpClient = getApi()) => ({
  loginAdministrator: async (
    data: LoginAdministratorRequest
  ): Promise<LoginResponse> => {
    const { data: response } = await client.post<LoginResponse>(
      "/auth/admin/login",
      data
    );
    return response;
  },

  verifyUser: async (data: VerifyUserRequest): Promise<boolean> => {
    const { data: response } = await client.post<boolean>(
      "/auth/verify-user",
      data
    );
    return response;
  },

  preLoginLifeguard: async (
    data: LifeguardPreLoginRequest
  ): Promise<LoginResponse> => {
    const { data: response } = await client.post<LoginResponse>(
      "/auth/lifeguard/pre-login",
      data
    );
    return response;
  },

  loginLifeguard: async (
    data: LoginLifeguardRequest
  ): Promise<LoginResponse> => {
    // Token is automatically added by axios interceptor from the store
    const { data: response } = await client.post<LoginResponse>(
      "/auth/lifeguard/login",
      data
    );
    return response;
  },
});

export type AuthEndpoints = ReturnType<typeof createAuthEndpoints>;

export const authEndpoints = createAuthEndpoints();
